var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-plugins" }, [
    _c("div", { staticClass: "plugins-header" }, [
      _c("div", { staticClass: "plugins-title" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.aiPluginsTitle"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "plugins-subtitle" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("chatbotv2.aiPluginsSubtitle")) +
            "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("🩹")]),
                _vm._v(
                  "\n                    Response Healing\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "purple" } },
                  [_vm._v(_vm._s(_vm.$t("chatbotv2.jsonRepair")))]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plugin-desc" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("chatbotv2.responseHealingDesc")) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.responseHealing.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("responseHealing", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.responseHealing.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c(
                "a-alert",
                { attrs: { type: "info", "show-icon": "" } },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("Response Healing Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "description" },
                    [
                      _c("p", [
                        _vm._v("Bu plugin, "),
                        _c("code", [_vm._v("response_format")]),
                        _vm._v(" ile "),
                        _c("code", [_vm._v("json_schema")]),
                        _vm._v(" veya "),
                        _c("code", [_vm._v("json_object")]),
                        _vm._v(
                          " kullandığınızda devreye girer ve aşağıdaki sorunları düzeltir:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _c("b", [_vm._v("JSON Sözdizimi Hataları")]),
                          _vm._v(
                            " – Eksik kapanış parantezleri, çift tırnak sorunları vb."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Markdown Sarmalama")]),
                          _vm._v(" – "),
                          _c("code", [_vm._v("```json ... ```")]),
                          _vm._v(" bloklarından JSON'ı çıkarır."),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Metin + JSON Karışımı")]),
                          _vm._v(
                            " – Yanıtın başındaki metin açıklamalarını siler, yalnızca JSON'ı alır."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Sondaki Virgüller")]),
                          _vm._v(" – "),
                          _c("code", [_vm._v('{"key": "val",}')]),
                          _vm._v(" gibi geçersiz virgülleri kaldırır."),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Tırnaksız Anahtarlar")]),
                          _vm._v(" – "),
                          _c("code", [_vm._v('{key: "val"}')]),
                          _vm._v(" → "),
                          _c("code", [_vm._v('{"key": "val"}')]),
                          _vm._v(" şekline dönüştürür."),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-alert",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { type: "warning" },
                        },
                        [
                          _c("template", { slot: "message" }, [
                            _vm._v("Yalnızca "),
                            _c("b", [_vm._v("streaming olmayan")]),
                            _vm._v(
                              " isteklerde çalışır. Kesilmiş (max_tokens aşımı) yanıtlar onarılamayabilir."
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("📄")]),
                _vm._v(
                  "\n                    PDF Inputs\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "orange" } },
                  [_vm._v("Dosya İşleme")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plugin-desc" }, [
              _vm._v(
                "\n                    Yüklenen PDF dosyalarını ayrıştırarak içeriklerini LLM'e metin olarak iletir. Dosya girişini desteklemeyen modeller dahil tüm modellerde PDF analizi yapmanızı sağlar.\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.pdfInput.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("pdfInput", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.pdfInput.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c("div", { staticClass: "detail-section" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "detail-desc" }, [
                  _vm._v(
                    "Hangi motorun kullanılacağını seçin. Fiyatlandırma motorlara göre değişir ve Supsis %10 işlem ücreti ekler."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "engine-cards" },
                  _vm._l(_vm.pdfEngines, function (eng) {
                    return _c(
                      "div",
                      {
                        key: eng.id,
                        staticClass: "engine-card",
                        class: {
                          selected: _vm.plugins.pdfInput.engine === eng.id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.setPdfEngine(eng.id)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "engine-card-header" },
                          [
                            _c("span", { staticClass: "engine-name" }, [
                              _vm._v(_vm._s(eng.name)),
                            ]),
                            _vm._v(" "),
                            eng.recommended
                              ? _c(
                                  "a-tag",
                                  {
                                    staticStyle: { "font-size": "11px" },
                                    attrs: { color: "green" },
                                  },
                                  [_vm._v("Önerilen")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-tag",
                              {
                                staticStyle: { "font-size": "11px" },
                                attrs: { color: eng.free ? "green" : "orange" },
                              },
                              [_vm._v(_vm._s(eng.priceLabel))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "engine-desc" }, [
                          _vm._v(_vm._s(eng.description)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-alert",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { type: "info", "show-icon": "" },
                },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("PDF Inputs Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "description" }, [
                    _c("p", [
                      _vm._v(
                        "PDF dosyaları URL veya base64 ile gönderilebilir. OpenRouter tüm modellerde PDF desteği sağlar:"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", [
                        _c("b", [_vm._v("Doğal Destek")]),
                        _vm._v(
                          ": Model PDF'yi doğrudan işliyorsa (native engine), dosya direkt iletilir."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("b", [_vm._v("Metin Dönüşümü")]),
                        _vm._v(
                          ": Model dosya desteklemiyorsa, OpenRouter PDF'yi ayrıştırarak içeriği metin olarak gönderir."
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-top": "8px" } }, [
                      _c("b", [
                        _vm._v("Fiyatlandırma (Supsis %10 ücret ekler):"),
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _c("code", [_vm._v("mistral-ocr")]),
                          _vm._v(" – ~$2.20 / 1.000 sayfa (Supsis %10 dahil)"),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("code", [_vm._v("pdf-text")]),
                          _vm._v(" – Ücretsiz"),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("code", [_vm._v("native")]),
                          _vm._v(
                            " – Input token ücreti kadar (model provider'a göre değişir)"
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("🌐")]),
                _vm._v(
                  "\n                    Web Search\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "blue" } },
                  [_vm._v("Gerçek Zamanlı Arama")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plugin-desc" }, [
              _vm._v(
                "\n                    LLM yanıtlarını gerçek zamanlı web arama sonuçlarıyla zenginleştirir. Herhangi bir modelde güncel bilgiye erişim sağlar.\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.webSearch.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("webSearch", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.webSearch.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c("div", { staticClass: "detail-row" }, [
                _c(
                  "div",
                  { staticClass: "detail-section", staticStyle: { flex: "1" } },
                  [
                    _c("div", { staticClass: "detail-label" }, [
                      _vm._v("Arama Motoru"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-desc" }, [
                      _vm._v("Hangi arama motorunun kullanılacağını seçin."),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          change: function ($event) {
                            return _vm.savePluginField(
                              "webSearch",
                              "engine",
                              $event
                            )
                          },
                        },
                        model: {
                          value: _vm.plugins.webSearch.engine,
                          callback: function ($$v) {
                            _vm.$set(_vm.plugins.webSearch, "engine", $$v)
                          },
                          expression: "plugins.webSearch.engine",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "" } }, [
                          _vm._v("Otomatik (Native varsa Native, yoksa Exa)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "native" } }, [
                          _vm._v(
                            "Native – LLM sağlayıcısının yerleşik web araması"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "exa" } }, [
                          _vm._v("Exa – Exa.ai web arama API'si"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "detail-section", staticStyle: { flex: "1" } },
                  [
                    _c("div", { staticClass: "detail-label" }, [
                      _vm._v("Maks. Sonuç Sayısı"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-desc" }, [
                      _vm._v(
                        "Döndürülecek web arama sonucu sayısı (varsayılan: 5)."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: { min: 1, max: 10 },
                      on: {
                        change: function ($event) {
                          return _vm.savePluginField(
                            "webSearch",
                            "maxResults",
                            $event
                          )
                        },
                      },
                      model: {
                        value: _vm.plugins.webSearch.maxResults,
                        callback: function ($$v) {
                          _vm.$set(_vm.plugins.webSearch, "maxResults", $$v)
                        },
                        expression: "plugins.webSearch.maxResults",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "detail-section",
                  staticStyle: { "margin-top": "12px" },
                },
                [
                  _c("div", { staticClass: "detail-label" }, [
                    _vm._v("Arama Bağlam Boyutu (Native modeller)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-desc" }, [
                    _vm._v(
                      "Native modellerde ne kadar arama bağlamı alınacağını belirler. Daha fazla bağlam daha yüksek maliyet demektir."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "context-cards" },
                    _vm._l(_vm.contextSizes, function (ctx) {
                      return _c(
                        "div",
                        {
                          key: ctx.id,
                          staticClass: "context-card",
                          class: {
                            selected:
                              _vm.plugins.webSearch.searchContextSize ===
                              ctx.id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setContextSize(ctx.id)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "context-name" }, [
                            _vm._v(_vm._s(ctx.name)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "context-desc" }, [
                            _vm._v(_vm._s(ctx.description)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-alert",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { type: "info", "show-icon": "" },
                },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("Web Search Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "description" }, [
                    _c("p", [
                      _vm._v(
                        "Web Search plugin'i, seçilen modele göre farklı motorlar kullanır:"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("ul", [
                      _c("li", [
                        _c("b", [_vm._v("Native")]),
                        _vm._v(
                          " – OpenAI, Anthropic, Perplexity, xAI modellerinde yerleşik arama kullanılır. xAI'de hem Web hem X araması etkinleşir."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("b", [_vm._v("Exa")]),
                        _vm._v(
                          " – Diğer tüm modellerde Exa.ai'nin arama API'si kullanılır. Anahtar kelime + embedding tabanlı \"auto\" modu ile en alakalı sonuçları bulur."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("b", [_vm._v("Otomatik")]),
                        _vm._v(
                          " – Native arama varsa kullanılır, yoksa Exa'ya geçilir."
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-top": "8px" } }, [
                      _c("b", [
                        _vm._v("Fiyatlandırma (Supsis %10 ücret ekler):"),
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _c("b", [_vm._v("Exa araması")]),
                          _vm._v(
                            " – ~$4.40 / 1.000 sonuç (Supsis %10 dahil). Varsayılan 5 sonuçta ~$0,022 / istek."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Native arama")]),
                          _vm._v(
                            " – Sağlayıcı fiyatına eklenir:\n                                "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://platform.openai.com/docs/pricing#built-in-tools",
                                target: "_blank",
                              },
                            },
                            [_vm._v("OpenAI")]
                          ),
                          _vm._v(",\n                                "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://docs.claude.com/en/docs/agents-and-tools/tool-use/web-search-tool#usage-and-pricing",
                                target: "_blank",
                              },
                            },
                            [_vm._v("Anthropic")]
                          ),
                          _vm._v(",\n                                "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://docs.perplexity.ai/getting-started/pricing",
                                target: "_blank",
                              },
                            },
                            [_vm._v("Perplexity")]
                          ),
                          _vm._v(",\n                                "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://docs.x.ai/docs/models#tool-invocation-costs",
                                target: "_blank",
                              },
                            },
                            [_vm._v("xAI")]
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("✂️")]),
                _vm._v(
                  "\n                    Message Transform (Middle-Out)\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "geekblue" } },
                  [_vm._v("Context Yönetimi")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plugin-desc" }, [
              _vm._v(
                "\n                    Context penceresi aşıldığında orta kısımdaki mesajları kırparak isteğin başarılı olmasını sağlar. LLM'lerin orta konumlara daha az dikkat ettiği bulgusu üzerine kurulmuştur.\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.messageTransform.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("messageTransform", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.messageTransform.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c(
                "a-alert",
                { attrs: { type: "info", "show-icon": "" } },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("Message Transform Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "description" },
                    [
                      _c("p", [
                        _vm._v(
                          "Mesaj geçmişi modelin maksimum context penceresini aştığında, bu dönüşüm otomatik olarak devreye girer:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ul", [
                        _c("li", [
                          _vm._v("Konuşmanın "),
                          _c("b", [_vm._v("ortasındaki")]),
                          _vm._v(" mesajlar kaldırılır veya kısaltılır."),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Başlangıç ve son")]),
                          _vm._v(
                            " mesajlar korunur; bu sayede bağlam bütünlüğü sağlanır."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v("Anthropic Claude gibi modellerde uygulanan "),
                          _c("b", [_vm._v("maksimum mesaj sayısı")]),
                          _vm._v(
                            " sınırı da aşıldığında devreye girer: baştan ve sondan eşit sayıda mesaj tutulur."
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "8px" } }, [
                        _c("b", [_vm._v("Ne zaman kullanmalısınız?")]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "✅ Uzun konuşmalar ve geniş knowledge base içerikleri olan chatbotlarda kesinlikle önerilir."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "✅ Context taşması nedeniyle hata alıyorsanız açın."
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "⚠️ Eksiksiz hatırlama kritikse (hukuki, tıbbi gibi alanlarda) dikkatli kullanın; orta mesajlar silinebilir."
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-alert",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { type: "warning" },
                        },
                        [
                          _c("template", { slot: "message" }, [
                            _vm._v(
                              "Not: 8.192 token veya daha küçük context'e sahip OpenRouter modellerinde bu dönüşüm zaten "
                            ),
                            _c("b", [_vm._v("varsayılan olarak aktiftir")]),
                            _vm._v(
                              ". Büyük context modelleri için manuel etkinleştirin."
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("🔍")]),
                _vm._v(
                  "\n                    LLM Powered – RAG Query Rewriter\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "volcano" } },
                  [_vm._v("Advanced RAG")]
                ),
                _vm._v(" "),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "gold" } },
                  [_vm._v("Token Optimizasyonu")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plugin-desc" }, [
              _vm._v(
                '\n                    Müşteri mesajını doğrudan embed etmek yerine, bir LLM aracılığıyla vektör aramasına özel, anlamlı ve bağımsız bir sorguya dönüştürür. Knowledge base\'inizin yazılı olduğu dile göre otomatik sorgu uyarlaması yapar; "teşekkürler" gibi anlamsız girişlerde RAG aramasını atlayarak token tasarrufu sağlar.\n                '
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.ragQueryRewrite.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("ragQueryRewrite", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.ragQueryRewrite.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c(
                "div",
                { staticClass: "detail-section" },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-desc" }, [
                    _vm._v(
                      "\n                    Dokümanlarınızın yüklendiği dili seçin. Müşteri farklı bir dilde yazsa bile sorgu bu dile çevrilerek vektör araması yapılır. Seçilmezse kullanıcının kendi dili korunur.\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "allow-clear": "",
                        placeholder: "Dil seçin (opsiyonel)",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.savePluginField(
                            "ragQueryRewrite",
                            "targetLanguage",
                            $event
                          )
                        },
                      },
                      model: {
                        value: _vm.plugins.ragQueryRewrite.targetLanguage,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.plugins.ragQueryRewrite,
                            "targetLanguage",
                            $$v
                          )
                        },
                        expression: "plugins.ragQueryRewrite.targetLanguage",
                      },
                    },
                    _vm._l(_vm.ragRewriteLanguages, function (lang) {
                      return _c(
                        "a-select-option",
                        { key: lang.value, attrs: { value: lang.value } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(lang.label) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-alert",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { type: "info", "show-icon": "" },
                },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("RAG Query Rewriter Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "description" },
                    [
                      _c("p", [
                        _vm._v(
                          "Bu plugin, her müşteri mesajından önce hafif bir LLM çağrısı yaparak vektör araması için optimize edilmiş bir sorgu üretir:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ol", [
                        _c("li", [
                          _c("b", [_vm._v("Bağlam Çözümleme")]),
                          _vm._v(
                            ' – "bu", "onu", "orası" gibi belirsiz referanslar önceki konuşmadan çözümlenir ve sorgu bağımsız hale getirilir.'
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Dil Uyarlama")]),
                          _vm._v(
                            " – Knowledge base Türkçe ise müşteri İngilizce yazsa bile sorgu Türkçeye çevrilerek arama yapılır; bu sayede semantic benzerlik skoru yükselir."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Akıllı Fallback")]),
                          _vm._v(
                            ' – "tamam", "teşekkürler", "merhaba" gibi RAG araması gerektirmeyen mesajlar tespit edilir ve RAG aşaması tamamen atlanır; gereksiz vektör araması ve token maliyeti önlenir.'
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Saf Niyet Korunması")]),
                          _vm._v(
                            " – LLM soruyu cevaplamaz, yalnızca arama için en uygun ifadeye dönüştürür."
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "8px" } }, [
                        _c("b", [_vm._v("Faydaları:")]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v(
                              "✅ Çok dilli müşterilerde bile tek dilde tutarlı vektör araması"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "✅ Belirsiz ve çok parçalı sorularda daha yüksek recall"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "✅ Anlamsız mesajlarda RAG atlanarak embedding maliyeti sıfırlanır"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(
                              "✅ Ana LLM context penceresi gereksiz belgelerle şişirilmez"
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-alert",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { type: "warning" },
                        },
                        [
                          _c("template", { slot: "message" }, [
                            _vm._v("Bu plugin yalnızca "),
                            _c("b", [_vm._v("Supsis RAG")]),
                            _vm._v(
                              " modunda çalışır. Her müşteri mesajı için küçük bir ek LLM maliyeti oluşur ve "
                            ),
                            _c("b", [_vm._v("rag-query-rewrite")]),
                            _vm._v(" adıyla cüzdanınızdan düşülür."),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("🧭")]),
                _vm._v(
                  "\n                    Auto Router\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "cyan" } },
                  [_vm._v("Otomatik Model Seçimi")]
                ),
                _vm._v(" "),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "green" } },
                  [_vm._v("Ücretsiz")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(2),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.autoRouter.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("autoRouter", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.autoRouter.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c(
                "div",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "detail-label" }, [
                    _vm._v("İzin Verilen Modeller (Opsiyonel)"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-desc" }, [
                    _vm._v(
                      "\n                    Boş bırakırsanız Auto Router yüksek kaliteli büyük modeller arasından seçim yapar. Model kısıtlamak için pattern ekleyebilirsiniz.\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        mode: "tags",
                        placeholder:
                          "Örn: anthropic/*, openai/gpt-5*, google/*",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.savePluginField(
                            "autoRouter",
                            "allowedModels",
                            $event
                          )
                        },
                      },
                      model: {
                        value: _vm.plugins.autoRouter.allowedModels,
                        callback: function ($$v) {
                          _vm.$set(_vm.plugins.autoRouter, "allowedModels", $$v)
                        },
                        expression: "plugins.autoRouter.allowedModels",
                      },
                    },
                    _vm._l(_vm.autoRouterPresets, function (p) {
                      return _c(
                        "a-select-option",
                        { key: p.value, attrs: { value: p.value } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(p.label) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "pattern-hint" }, [
                    _c(
                      "div",
                      { staticClass: "pattern-table" },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._l(_vm.patternExamples, function (p) {
                          return _c(
                            "div",
                            { key: p.pattern, staticClass: "pattern-row" },
                            [
                              _c("code", [_vm._v(_vm._s(p.pattern))]),
                              _c("span", [_vm._v(_vm._s(p.desc))]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-alert",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { type: "info", "show-icon": "" },
                },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("Auto Router Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "description" },
                    [
                      _c("p", [
                        _vm._v(
                          "NotDiamond'ın yönlendirme sistemi prompt'unuzu analiz ederek en uygun modeli seçer:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ol", [
                        _c("li", [
                          _c("b", [_vm._v("Prompt Analizi")]),
                          _vm._v(
                            " – Karmaşıklık, görev türü ve model kabiliyetleri değerlendirilir."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Model Seçimi")]),
                          _vm._v(
                            " – Yüksek kaliteli modeller havuzundan optimal model belirlenir."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Yanıtta Hangi Model Seçildi?")]),
                          _vm._v(" – API yanıtında "),
                          _c("code", [_vm._v("model")]),
                          _vm._v(" alanı gerçekte kullanılan modeli gösterir."),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "8px" } }, [
                        _c("b", [
                          _vm._v(
                            "Varsayılan Model Havuzu (pattern belirtilmezse):"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _vm._v("Claude Sonnet / Opus (Anthropic)"),
                          ]),
                          _vm._v(" "),
                          _c("li", [_vm._v("GPT-5.x (OpenAI)")]),
                          _vm._v(" "),
                          _c("li", [_vm._v("Gemini 3 Pro (Google)")]),
                          _vm._v(" "),
                          _c("li", [_vm._v("DeepSeek v3 (DeepSeek)")]),
                          _vm._v(" "),
                          _c("li", [_vm._v("ve diğer üst düzey modeller")]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-alert",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { type: "success" },
                        },
                        [
                          _c("template", { slot: "message" }, [
                            _vm._v("Auto Router'ın kullanımı "),
                            _c("b", [_vm._v("ücretsizdir")]),
                            _vm._v(
                              ". Yalnızca seçilen modelin standart fiyatı ödenir."
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "plugin-card" }, [
      _c(
        "div",
        { staticClass: "plugin-card-header" },
        [
          _c("div", { staticClass: "plugin-info" }, [
            _c(
              "div",
              { staticClass: "plugin-name" },
              [
                _c("span", { staticClass: "plugin-icon" }, [_vm._v("🏆")]),
                _vm._v(
                  "\n                    RAG ReRank\n                    "
                ),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "purple" } },
                  [_vm._v("Advanced RAG")]
                ),
                _vm._v(" "),
                _c(
                  "a-tag",
                  { staticClass: "plugin-tag", attrs: { color: "red" } },
                  [_vm._v("Ücretli")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "plugin-desc" }, [
              _vm._v(
                "\n                    Vektör aramasından dönen belgeler doğrudan AI'ya verilmek yerine, Voyage AI'ın Reranker modeli ile sorguya göre yeniden sıralanır. En alakalı belgeler üst sıralara taşınarak AI yanıtlarının doğruluğu artırılır.\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-switch", {
            attrs: { checked: _vm.plugins.ragRerank.enabled },
            on: {
              change: function (v) {
                return _vm.togglePlugin("ragRerank", v)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plugins.ragRerank.enabled
        ? _c(
            "div",
            { staticClass: "plugin-detail" },
            [
              _c("div", { staticClass: "detail-section" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "detail-desc" }, [
                  _vm._v(
                    "Hangi modelin kullanılacağını seçin. Fiyatlar 1.000 token başınadır."
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "engine-cards" },
                  _vm._l(_vm.rerankModels, function (m) {
                    return _c(
                      "div",
                      {
                        key: m.id,
                        staticClass: "engine-card",
                        class: {
                          selected: _vm.plugins.ragRerank.model === m.id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.savePluginField(
                              "ragRerank",
                              "model",
                              m.id
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "engine-card-header" },
                          [
                            _c("span", { staticClass: "engine-name" }, [
                              _vm._v(_vm._s(m.id)),
                            ]),
                            _vm._v(" "),
                            m.recommended
                              ? _c(
                                  "a-tag",
                                  {
                                    staticStyle: { "font-size": "11px" },
                                    attrs: { color: "green" },
                                  },
                                  [_vm._v("Önerilen")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a-tag",
                              {
                                staticStyle: { "font-size": "11px" },
                                attrs: { color: "orange" },
                              },
                              [_vm._v(_vm._s(m.priceLabel))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "engine-desc" }, [
                          _vm._v(_vm._s(m.description)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-alert",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { type: "info", "show-icon": "" },
                },
                [
                  _c("template", { slot: "message" }, [
                    _vm._v("RAG ReRank Nasıl Çalışır?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "description" },
                    [
                      _c("p", [
                        _vm._v(
                          "RAG pipeline'ına ikinci bir aşama ekler; vektör aramasının sıralama hatalarını düzeltir:"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ol", [
                        _c("li", [
                          _c("b", [_vm._v("Vektör Arama")]),
                          _vm._v(
                            " – Cosine similarity ile en yakın belgeler bulunur (hız için tasarlandı)."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("ReRank")]),
                          _vm._v(
                            " – Voyage AI'ın Reranker modeli her belgeyi sorguyla derin semantik benzerlik açısından değerlendirir ve gerçek alaka puanı hesaplar."
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("b", [_vm._v("Sıralı Context")]),
                          _vm._v(
                            " – En alakalı belgeler üst sıralara alınarak AI'ya verilir; düşük alakalı belgeler sona itilir."
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "margin-top": "8px" } }, [
                        _c("b", [
                          _vm._v("Fiyatlandırma (1.000 token başına):"),
                        ]),
                        _vm._v(" "),
                        _c("ul", [
                          _c("li", [
                            _c("code", [_vm._v("rerank-2.5")]),
                            _vm._v(" – $0,000075 / 1K token"),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("code", [_vm._v("rerank-2.5-lite")]),
                            _vm._v(" – $0,00003 / 1K token"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("small", [
                          _vm._v(
                            "* Fiyat: (sorgu token sayısı × belge sayısı) + tüm belge tokenları toplamı üzerinden hesaplanır."
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-alert",
                        {
                          staticStyle: { "margin-top": "8px" },
                          attrs: { type: "warning" },
                        },
                        [
                          _c("template", { slot: "message" }, [
                            _vm._v("Bu plugin yalnızca "),
                            _c("b", [_vm._v("Supsis RAG")]),
                            _vm._v(" modunda çalışır ve her mesaj için "),
                            _c("b", [_vm._v("ai-rag-rerank")]),
                            _vm._v(" adıyla cüzdanınızdan düşülür."),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.saved
      ? _c(
          "div",
          { staticClass: "save-info" },
          [
            _c("a-alert", {
              attrs: {
                type: "success",
                message: "Plugin ayarları kaydedildi.",
                closable: "",
                "after-close": function () {
                  return (_vm.saved = false)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-label" }, [
      _vm._v("PDF İşleme Motoru "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-label" }, [
      _vm._v("Knowledge Base Dili "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plugin-desc" }, [
      _vm._v(
        "\n                    Her prompt için en uygun modeli otomatik seçer. NotDiamond tarafından desteklenmektedir. Aktif olduğunda seçilen Primary Model yerini "
      ),
      _c("code", [_vm._v("openrouter/auto")]),
      _vm._v("'ya bırakır.\n                "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pattern-row header" }, [
      _c("span", [_vm._v("Pattern")]),
      _c("span", [_vm._v("Eşleşen Modeller")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-label" }, [
      _vm._v("ReRank Modeli "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }